import type { AsyncFieldConfiguration } from '@atlassian/proforma-form-renderer/async-fields';
import type { IssueFieldData } from '@atlassian/proforma-form-renderer/field-data';
import type { ProformaForm } from '@atlassian/proforma-form-renderer/proforma-form';

import type { useAffectedServices } from '../../affected-services';
import type { useCmdbObjects } from '../../cmdb-objects';
import {
	AFFECTED_SERVICES_SCHEMA_CUSTOM,
	CMDB_SCHEMA_CUSTOM,
	LABELS_SCHEMA_CUSTOM,
	LABELS_SCHEMA_SYSTEM,
} from '../../constants';
import type { useLabels } from '../../labels';

export const resolveSchemaConfig = (
	jiraFieldKey: string,
	fieldData: IssueFieldData,
	affectedServicesFn: ReturnType<typeof useAffectedServices>,
	cmdbObjectsFn: ReturnType<typeof useCmdbObjects>,
	labelsFn: ReturnType<typeof useLabels>,
	proformaForm: ProformaForm,
): AsyncFieldConfiguration | undefined => {
	const customSchema = fieldData.schema?.custom;
	const systemSchema = fieldData.schema?.system;

	if (systemSchema === LABELS_SCHEMA_SYSTEM) {
		return labelsFn(true, jiraFieldKey);
	}

	if (customSchema === AFFECTED_SERVICES_SCHEMA_CUSTOM) {
		return affectedServicesFn();
	}

	if (customSchema === CMDB_SCHEMA_CUSTOM && fieldData.fieldConfigId !== undefined) {
		return cmdbObjectsFn(jiraFieldKey, fieldData.attributes || [], proformaForm);
	}

	if (customSchema === LABELS_SCHEMA_CUSTOM) {
		return labelsFn(false, jiraFieldKey);
	}

	return undefined;
};
